export const optionSkeleton = [];